import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { Actions } from '../actions/programBookDownload-actions';
import { ProgramBookDownloadActions } from '../constants';
import { IProgramBookDownload } from 'src/types/programBookDownload';

export interface ProgramBookDownloadState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IProgramBookDownload>;
    current: IProgramBookDownload | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],

        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
};

export function programBookDownloads(
    state: ProgramBookDownloadState = initialState,
    action: Actions | any,
): ProgramBookDownloadState {
    switch (action.type) {
        case requestType(ProgramBookDownloadActions.PERSIST_PROGRAM_BOOK_DOWNLOAD):
            return { ...state, error: '', inProgress: true };
        case successType(ProgramBookDownloadActions.PERSIST_PROGRAM_BOOK_DOWNLOAD):
            return { ...state, current: action.payload, inProgress: false };
        case failureType(ProgramBookDownloadActions.PERSIST_PROGRAM_BOOK_DOWNLOAD):
            return { ...state, error: action.error, inProgress: false };
        case requestType(ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOADS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOADS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOADS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOAD):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOAD):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOAD):
            return { ...state, inProgress: false, error: action.error };
        case requestType(ProgramBookDownloadActions.DELETE_PROGRAM_BOOK_DOWNLOAD):
            return { ...state, error: '', inProgress: true };
        case successType(ProgramBookDownloadActions.DELETE_PROGRAM_BOOK_DOWNLOAD):
            let idDel = action.payload.id;
            if (!idDel) {
                idDel = action.sagaPayload.id;
            }
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IProgramBookDownload) => {
                        return user.id !== idDel;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(ProgramBookDownloadActions.DELETE_PROGRAM_BOOK_DOWNLOAD):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
